import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

export default class productsView extends JetView {
    /**
     * Configures the view layout and initializes data handling.
     * @returns {Object} The layout configuration for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var send = {
            // Object to hold product and financial data
            products: [],
            total: {
                expense: 0,
                incomes: 0,
                total: 0,
            },
            expenses: [],
            incomes: [],
        };

        // Event listener for 'productsObject' event
        this.on(this.app, 'productsObject', (filter) => {
            $$('gridProduct2').data.each(function (obj) {
                send.products.push(obj); // Collecting products
                send.products.splice($$('gridProduct2').count()); // Adjusting the products array
            });
        });

        // Delayed execution to collect products after a timeout
        webix.delay(
            function () {
                $$('gridProduct2').data.each(function (objj) {
                    send.products.push(objj); // Collecting products
                    send.products.splice($$('gridProduct2').count()); // Adjusting the products array
                });
            },
            '',
            '',
            1000,
        );

        // Event listener for 'expensesObject' event
        this.on(this.app, 'expensesObject', (filter) => {
            send.expenses = []; // Resetting expenses
            $$('grid2').data.each(function (obj) {
                send.expenses.push(obj); // Collecting expenses
            });
        });

        // Event listener for 'incomesObject' event
        this.on(this.app, 'incomesObject', (filter) => {
            send.incomes = []; // Resetting incomes
            $$('gridIncomes2').data.each(function (obj) {
                send.incomes.push(obj); // Collecting incomes
            });
        });

        // Returning the layout configuration
        return {
            rows: [
                {
                    view: 'text',
                    label: 'Total Ingresos:', // Label for total incomes
                    labelWidth: 120,
                    readonly: true,
                    id: 'totalIncomes', // ID for total incomes field
                },
                {
                    view: 'text',
                    label: 'Total Egresos:', // Label for total expenses
                    labelWidth: 120,
                    readonly: true,
                    id: 'totalExpenses', // ID for total expenses field
                },
                {
                    view: 'text',
                    label: 'Total:', // Label for overall total
                    labelWidth: 120,
                    readonly: true,
                    id: 'total', // ID for overall total field
                },
                {
                    cols: [
                        {
                            view: 'button',
                            label: 'Cerrar día', // Button to close the day
                            click: function () {
                                // Validation for grids before closing the day
                                if (
                                    $$('grid2').validate() &&
                                    $$('gridIncomes2').validate() &&
                                    $$('gridProduct2').validate()
                                ) {
                                    send.total.expense = $$('totalExpenses').getValue(); // Getting total expenses
                                    send.total.incomes = $$('totalIncomes').getValue(); // Getting total incomes
                                    send.total.total = $$('total').getValue(); // Getting overall total
                                    console.log(send); // Logging the collected data
                                } else {
                                    // Displaying error message if validation fails
                                    webix.message({
                                        text: 'Verifique que todos los datos sean validos ',
                                        title: '¡Error!',
                                        type: 'alert-error',
                                    });
                                }
                            },
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes event listeners and calculates totals.
     */
    init() {
        var expensesTotal = 0; // Total expenses variable
        var incomesTotal = 0; // Total incomes variable
        var totalExpenses = 0; // Total expenses from different sources
        var totalExpensesProducts = 0; // Total expenses from products

        // Event listener for total expenses sum
        this.on(this.app, 'totalExpenses:sum', (sum) => {
            totalExpenses = sum.total; // Updating total expenses
            sumExpenses(); // Calculating total expenses
        });

        // Event listener for total expenses from products sum
        this.on(this.app, 'totalExpensesProducts:sum', (sum) => {
            totalExpensesProducts = sum.total; // Updating total expenses from products
            sumExpenses(); // Calculating total expenses
        });

        /**
         * Calculates and updates total expenses.
         */
        function sumExpenses() {
            expensesTotal = totalExpenses + totalExpensesProducts; // Summing total expenses
            $$('totalExpenses').setValue(expensesTotal); // Setting total expenses value
            sumTotal(); // Calculating overall total
        }

        var totalIncomes = 0; // Total incomes variable
        var totalIncomesProducts = 0; // Total incomes from products

        // Event listener for total incomes sum
        this.on(this.app, 'totalIncomes:sum', (sum) => {
            totalIncomes = sum.total; // Updating total incomes
            sumIncomes(); // Calculating total incomes
        });

        // Event listener for total incomes from products sum
        this.on(this.app, 'totalIncomesProducts:sum', (sum) => {
            totalIncomesProducts = sum.total; // Updating total incomes from products
            sumIncomes(); // Calculating total incomes
        });

        /**
         * Calculates and updates total incomes.
         */
        function sumIncomes() {
            incomesTotal = totalIncomes + totalIncomesProducts; // Summing total incomes
            $$('totalIncomes').setValue(incomesTotal); // Setting total incomes value
            sumTotal(); // Calculating overall total
        }

        /**
         * Calculates and updates the overall total.
         */
        function sumTotal() {
            var total = incomesTotal - expensesTotal; // Calculating overall total
            $$('total').setValue(total); // Setting overall total value
        }
    }
}

// FILE DOCUMENTED
